import React, { useEffect, useState } from 'react';

type PDFViewerProp = {
  url: string;
  fullscreen?: boolean;
  height?: string|number;
};

const PDFViewer: React.FC<PDFViewerProp> = ({ url, fullscreen = false, height = undefined }) => {
  const [error, setError] = useState('');

  useEffect(() => {
    setError('');
  }, [url]);

  if (error) {
    return (
      <div className="flex justify-content-center align-items-start">
        <p>
          Error: {error} - {url}
        </p>
      </div>
    );
  }
  const style = fullscreen ? { width: `calc(100vw - 10px)`, height: `calc(100vh - 10px)` } : { height: height || '100%' };
  console.log('[PDF VIEWER]', {style, url})
  return (
    <div
      className=""
      style={{ ...style, minHeight: '100%', overflow: 'auto' }}
    >
      <iframe title="pdfViewer" src={url + '#view=fitW'} height={'100%'} width={'100%'} style={{ display: 'block', background: '#000', border: 'none'}} />
    </div>
  );
};

export default PDFViewer;
